import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { ApiService } from '../api.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { User } from '../User';
import { AlertService } from '../alert.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
resetToken:string; //get token from url
private user: User = new User();
debugData: Boolean = true; // to show and hide the console log messages
validData:boolean =false;
  constructor(@Inject(LOCAL_STORAGE) private storage: WebStorageService,private route: ActivatedRoute, 
  private router: Router, private apiService: ApiService, private httpClient: HttpClient,private alertService: AlertService)
   {
    this.route.paramMap.subscribe(
      params => {
        this.resetToken= this.route.snapshot.paramMap.get('token');
        //console.log("Token");
       //console.log(this.resetToken);
      }
    );
    this.verifyToken();
    }

  ngOnInit() {

  }

// verifyPasswordToken

// {token:}
resetErrorMsg:string; //shows reset error message
resetMessage:string; //shows error msg
buttonDisabled: boolean;
verifyToken()
{
  let getToken = {token:this.resetToken};
  this.httpClient.post(this.apiService.verifyPasswordURL, getToken)
  .subscribe(
    (resetData:any) =>{
      //console.log("verify token");
      //console.log(resetData);
      if (resetData.status == true) {
        //this.resetErrorMsg = "success";
        this.user.id=resetData.id;
        this.validData=true
       // console.log(this.user.id);
      } else {
        this.resetErrorMsg = "Link is invalid"
        this.validData=false;
       // this.buttonDisabled = false;
      }
    }
  )
}
changePassword(userPassword)
{
  let getChangePwdData = { 'token': this.resetToken, 'id': this.user.id, 'password':userPassword };
  console.log(getChangePwdData);
  this.httpClient.post(this.apiService.changePasswordURL, getChangePwdData)
    .subscribe(
      (pwdreset: any) => {
         if (this.debugData) {
          console.log("reset password ")
          console.log(pwdreset);
        }
          if (pwdreset.status == true) {
          //this.user=pwdreset;
          console.log("success");
          this.resetMessage="Passworsd change successfully;"
          this.router.navigate(['/login-signup']);
          //this.apiService.refresh();
          return true;
        } else {
          this.resetMessage="Link is expired"
          return false;
        }
      },
      (err) => {
        console.log("error")
      });
}
showError(msg) {
  this.warn("Some Error Occured please try again");
}
warn(message: string) {
  this.alertService.warn(message);
}
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/reset-password/reset-password.component.ts